import React from 'react';
import { Navigate } from 'react-router-dom';

// Lazy load components
const Donors = React.lazy(() => import('../pages/Donors/Donors'));
const NewDonor = React.lazy(() => import('../pages/Donors/NewDonor'));
const DonorDetail = React.lazy(() => import('../pages/Donors/DonorDetail'));
const DonorEdit = React.lazy(() => import('../pages/Donors/DonorEdit'));
const ReminderDetails = React.lazy(() => import('../pages/Reminders/ReminderDetails'));
const Reminders = React.lazy(() => import('../pages/Reminders/Reminders'));
const NewTask = React.lazy(() => import('../pages/Hub/NewTask'));

export const getDonorRoutes = (loggedIn, visibleTabs, location, loginRedirect) => [
  {
    path: '/donors-list',
    element: (loggedIn && visibleTabs?.includes('Donors'))
      ? <Donors />
      : <Navigate to={loginRedirect} state={{ from: location }} replace />,
    children: [
      {
        path: 'new-donor',
        element: (loggedIn && visibleTabs?.includes('Donors'))
          ? <NewDonor />
          : <Navigate to={loginRedirect} state={{ from: location }} replace />
      },
      {
        path: 'donor-details',
        element: (loggedIn && visibleTabs?.includes('Donors'))
          ? <DonorDetail />
          : <Navigate to={loginRedirect} state={{ from: location }} replace />
      },
      {
        path: 'donor-edit',
        element: (loggedIn && visibleTabs?.includes('Donors'))
          ? <DonorEdit />
          : <Navigate to={loginRedirect} state={{ from: location }} replace />
      },
      {
        path: 'reminder-details/:reminderId',
        element: (loggedIn && visibleTabs?.includes('Donors'))
          ? <ReminderDetails />
          : <Navigate to={loginRedirect} state={{ from: location }} replace />
      }
    ]
  },
  {
    path: '/reminders-list',
    element: (loggedIn && visibleTabs?.includes('Donors_Reminders'))
      ? <Reminders />
      : <Navigate to={loginRedirect} state={{ from: location }} replace />,
    children: [
      {
        path: 'reminder-details/:reminderId',
        element: (loggedIn && visibleTabs?.includes('Donors_Reminders'))
          ? <ReminderDetails />
          : <Navigate to={loginRedirect} state={{ from: location }} replace />
      },
      {
        path: 'new-reminder',
        element: (loggedIn && visibleTabs?.includes('Donors_Reminders'))
          ? <NewTask />
          : <Navigate to={loginRedirect} state={{ from: location }} replace />
      }
    ]
  }
];

